import { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Header from './Header'
import Sidebar from './Sidebar'
import { useAuth } from '../../context/AuthContext'

const DashboardLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const [isCollapsed, setIsCollapsed] = useState(false)
  const location = useLocation()
  const { user, isAuthenticated } = useAuth()

  const handleMenuClick = () => setIsSidebarOpen((s) => !s)
  const handleCloseSidebar = () => setIsSidebarOpen(false)
  const toggleCollapse = () => setIsCollapsed((prev) => !prev)

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-slate-900 transition-colors duration-200">
      <Sidebar
        isOpen={isSidebarOpen}
        onClose={handleCloseSidebar}
        isCollapsed={isCollapsed}
        toggleCollapse={toggleCollapse}
      />
      <div className={`transition-all duration-300 ease-in-out ${isCollapsed ? 'lg:pl-20' : 'lg:pl-64'}`}>
        <Header onMenuClick={handleMenuClick} />
        {/* Debug bar: shows current path and auth state to help diagnose empty page issues */}
        <main className="p-4">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export default DashboardLayout
